'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Closecircle;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Closecircle(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z',
    id: 'Path'
  }), _react2.default.createElement('path', {
    d: 'M12,10.0402086 L9.40956078,7.41841862 C8.85834042,6.86052713 7.96463563,6.86052713 7.41341527,7.41841862 C6.86219491,7.97631011 6.86219491,8.88083093 7.41341527,9.43872242 L10.0038545,12.0605124 L7.53299281,14.5612776 C6.98177245,15.1191691 6.98177245,16.0236899 7.53299281,16.5815814 C8.08421318,17.1394729 8.97791796,17.1394729 9.52913832,16.5815814 L12,14.0808162 L14.4708617,16.5815814 C15.022082,17.1394729 15.9157868,17.1394729 16.4670072,16.5815814 C17.0182275,16.0236899 17.0182275,15.1191691 16.4670072,14.5612776 L13.9961455,12.0605124 L16.5865847,9.43872242 C17.1378051,8.88083093 17.1378051,7.97631011 16.5865847,7.41841862 C16.0353644,6.86052713 15.1416596,6.86052713 14.5904392,7.41841862 L12,10.0402086 L12,10.0402086 Z',
    fill: 'white',
    id: 'path-1'
  }));
}
Closecircle.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};